// 斯洛伐克语
const sk = {
  common: {
    notSupport: 'Váš prehliadač nepodporuje režim celej obrazovky',
    loadFail: 'Načítanie témy zlyhalo',
    noPermission: 'Prepáčte, nemáte povolenie na prístup k tejto stránke',
    backHome: 'Vrátiť sa na domovskú stránku',
    noExit: 'Stránka, ktorú sa pokúšate otvoriť, neexistuje',
    serverError: 'Prepáčte, server zaznamenal chybu',
    slide: 'Potiahnite doprava',
    veryHigh: 'Veľmi vysoká',
    high: 'Vysoká',
    target: 'Cieľ',
    urgentLow: 'Veľmi nízka',
    agpNoData: 'Na vygenerovanie správy AGP je potrebných aspoň 5 dní údajov',
    noDataStr: 'Žiadne údaje',
    setting: 'Nastavenie',
    personInfo: 'Základné informácie',
    updatePwd: 'Zmeniť heslo',
    upHead: 'Nahrať obrázky',
    inRange: 'V rozmedzí',
    normal: 'Normálna',
    low: 'Nízka',
    previous: 'Predchádzajúce',
    next: 'Ďalej',
    search: 'Hľadať',
    reset: 'Obnoviť',
    cancel: 'Zrušiť',
    ok: 'Ok',
    confirm: 'Potvrdiť',
    save: 'Uložiť',
    submit: 'Odoslať',
    successful: 'Úspešné',
    pleaseEnter: 'Zadajte, prosím',
    pleaseSelect: 'Prosím vyberte',
    success: 'Úspech',
    confirmLogout: 'Ste si istí, že sa chcete odhlásiť?',
    updateSuccessed: 'Aktualizácia bola úspešná',
    warning: 'Upozornenie',
    date: 'Dátum',
    start: 'Začiatok',
    end: 'Koniec',
    sevenDays: '7 dní',
    fourteenDays: '14 dní',
    thirtyDays: '30 dní',
    signOut: 'Odhlásiť sa',
    personalInformation: 'Osobné údaje',
    email: 'E-mail',
    name: 'Meno',
    mobile: 'Mobil',
    dateOfBirth: 'Dátum narodenia',
    gender: 'Pohlavie',
    diabeteType: 'Typ cukrovky',
    dateOfDignose: 'Rok diagnózy',
    remarks: 'Poznámky',
    optionMale: 'Muž',
    optionFemale: 'Žena',
    optionUnknow: 'Nechcem uviesť',
    noDiabetes: 'Žiadna cukrovka',
    diabeteTypeI: 'Typ I',
    diabeteTypeII: 'Typ II',
    diabeteSpecial: 'Špeciálne',
    diabeteGestational: 'Gestačný diabetes',
    diabeteOthers: 'Ostatné',
    ruleMsgEmail: 'Zadajte e-mail',
    ruleMsgName: 'Zadajte meno',
    ruleMsgMobile: 'Zadajte mobil',
    ruleMsgBirthday: 'Vyberte dátum narodenia',
    ruleMsgSex: 'Vyberte pohlavie',
    ruleMsgDiabeteType: 'Vyberte typ cukrovky',
    ruleMsgDateOfDignose: 'Vyberte rok diagnózy',
    ruleMsgRemarks: 'Zadajte poznámky',
    ruleMsgCorrectMobile: 'Zadajte správne mobilné číslo',
    oldPassword: 'Staré heslo',
    newPassword: 'Nové heslo',
    confirmPassword: 'Potvrďte heslo',
    ruleMsgOldPassword: 'Zadajte staré heslo',
    ruleMsgNewPassword: 'Zadajte nové heslo',
    ruleMsgConfirmPassword: 'Potvrďte heslo',
    passwordInconsistent: 'Zadané heslá sa nezhodujú',
    passwordModifySuccessed: 'Vaše heslo bolo resetované, prihláste sa znova!',
    monday: 'Po',
    tuesday: 'Ut',
    wednesday: 'St',
    thursday: 'Št',
    friday: 'Pi',
    saturday: 'So',
    sunday: 'Ne',
    sn: 'SN',
    startDate: 'Dátum začiatku',
    days: 'dni',
    pdfDate: 'Cieľ',
    close: 'zavrieť',
    inputTip: 'Zadajte kľúčové slová na vyhľadávanie',
    polarization: 'Inicializácia zariadenia',
    hour: 'h',
    minutes: 'min',
    seconds: 's',
    reportDownLoadTip: 'Vaša správa nebola vygenerovaná 5 dní.',
    age: 'vek',
    goal: 'Cieľ',
    expired: 'Platnosť senzora vypršala',
    lastTime: 'Čas poslednej aktualizácie',
    timeZone: 'Časové pásmo'
  },
  route: {
    login: 'Prihlásiť sa',
    forget: 'Zabudnuté heslo',
    home: 'Domov',
    glucoseReport: 'Správa o glukóze',
    sessionReport: 'Správa zo sedenia',
    eventList: 'Zoznam udalostí',
    followerList: 'Zoznam sledovateľov',
    followerListQ: 'Žiadosť o sledovanie',
    settings: 'Nastavenia',
    profile: 'Profil'
  },
  login: {
    rememberMe: 'Zapamätať si ma',
    forgetPassword: 'Zabudnuté heslo',
    agree: 'Prihlásením súhlasíte s FurCarer',
    privacyPolicy: 'Zásady ochrany osobných údajov',
    CGMUser: 'Používateľ CGM',
    follower: 'Sledovateľ',
    ruleMsgPassword: 'Zadajte heslo',
    login: 'Prihlásiť sa',
    phonePlacehold: 'Zadajte telefónne číslo',
    codePlacehold: 'Zadajte overovací kód',
    phoneTip: 'Telefonicky',
    emialTip: 'E-mailom',
    codeTip: 'Získať overovací kód',
    reGetTip: 'Získať znova'
  },
  layout: {
    collapseUp: 'Skryť menu',
    collapseDown: 'Rozbaliť menu',
    refresh: 'Obnoviť',
    backHome: 'Domov',
    helpCenter: 'Centrum pomoci',
    fullScreen: 'Celá obrazovka'
  },
  forget: {
    ruleMsgCode: 'Zadajte kód',
    sendCode: 'Odoslať kód',
    tipsMsgSendSuccess: 'Overovací kód bol úspešne odoslaný!',
    tipsMsgModifySuccess: 'Úprava hesla bola úspešná'
  },
  home: {
    todaysGlucose: 'Dnešná glukóza',
    todaysOverview: 'Dnešný prehľad',
    maxGlucose: 'Max. glukóza',
    minGlucose: 'Min. glukóza',
    avgGlucose: 'Priemerná glukóza',
    maxmumVariation: 'Maximálna variabilita',
    glucose: 'Glukóza',
    tir: 'TIR',
    latestGlucose: 'Najnovšia glukóza',
    todayPercentage: '% dnešného dňa v rôznych rozmedziach',
    fourHour: '4 hodiny',
    eightHour: '8 hodín',
    twelveHour: '12 hodín',
    twentyFourHour: '24 hodín',
    glucoseOnly: 'Len glukóza',
    sessionOverview: 'Prehľad sedenia',
    glocuseMetrics: 'Metodika glukózy',
    agp: 'AGP',
    dailyGlucose: 'Denná glukóza',
    sessionGlucose: 'Glukóza zo sedenia',
    standTir: 'Štandardné TIR',
    customTir: 'Prispôsobené TIR',
    cancleGz: 'Prestať sledovať',
    cancleText: 'Chcete prestať sledovať aktuálneho používateľa?',
    helpCenterTip: 'Funkcia ešte nie je dostupná'
  },
  glucoseReport: {
    statics: 'Štatistiky',
    sixHour: 'TIR za 6 hodín',
    avgGlucose: 'Priemerná glukóza',
    maxGlucose: 'Maximálna glukóza',
    minGlucose: 'Minimálna glukóza',
    cv: 'CV',
    high: 'Počet vysokých hodnôt',
    low: 'Počet nízkych hodnôt',
    normal: 'Počet normálnych hodnôt',
    tir: 'TIR',
    estimatedA1c: 'Odhadované A1c',
    min: 'Min',
    avg: 'Priemer',
    max: 'Max',
    maxVariation: 'Maximálna variabilita'
  },
  glucoseProfile: {
    avg: 'Priemer',
    sd: 'SD',
    cv: 'CV'
  },
  eventList: {
    all: 'Všetko',
    bg: 'BG',
    meal: 'Jedlo',
    sport: 'Šport',
    insulin: 'Inzulín',
    alert: 'Upozornenie',
    eventType: 'Typ udalosti',
    description: 'Popis',
    note: 'Poznámka',
    highAlert: 'varovanie upozornenia',
    calibration: 'Kalibrácia',
    meds: 'Lieky',
    time: 'Čas',
    detail: 'Detail',
    weigt: 'Hmotnosť'
  },
  followerList: {
    title: 'Monitorovaní používatelia',
    tabTitle: 'Správa sledovateľov',
    refreshText:
      'Automatické obnovenie (zoznam používateľov sa obnovuje každých 30 sekúnd)',
    addText: 'Pridať',
    dataText: 'Údaje získané',
    timeText: 'minút',
    hourText: 'hodín',
    agoText: 'dozadu',
    tableEmail: 'Zadajte číslo účtu',
    searchPlacehold: 'Zadajte svoje číslo účtu na vyhľadávanie',
    pending: 'Čaká sa',
    approved: 'Schválené',
    rejected: 'Zamietnuté',
    addFollower: 'Pridať sledovateľa',
    editFollower: 'Upraviť sledovateľa',
    tableName: 'Meno',
    tableAddTime: 'Čas pridania',
    tableStatus: 'Stav',
    tableApproved: 'Schválené',
    tableReject: 'Zamietnuť',
    tableStartSharing: 'Začať zdieľať',
    tableStopSharing: 'Zastaviť zdieľanie',
    op: 'Operovať',
    sharing: 'Zdieľanie',
    notSharing: 'Nezdieľa sa',
    tableRemove: 'odstrániť',
    note: 'Poznámka',
    message: 'Správa',
    ruleMsgEmailEmpty: 'Zadajte e-mail na vyhľadávanie',
    ruleMsgNote: 'Zadajte poznámku',
    ruleMsgMessage: 'Zanechajte správu',
    ruleMsgEmailCorrect: 'Zadajte správny e-mail',
    formAcknowledge:
      'Beriem na vedomie, že pridaním sledovateľa tomuto používateľovi umožním vidieť moje údaje',
    sendFollowRequest: 'Odoslať žiadosť o sledovanie',
    setNote: 'Nastaviť poznámku',
    tipsAcknowledge:
      'Začiarknite políčko, beriete na vedomie, že pridaním sledovateľa tomuto používateľovi umožníte vidieť vaše údaje',
    stopSharing: 'Zastaviť zdieľanie',
    startSharing: 'Začať zdieľať',
    removeUser: 'Odstrániť používateľa',
    confirmStopSharing:
      'Ste si istí, že chcete prestať zdieľať údaje o glukóze s týmto používateľom?',
    confirmStartSharing:
      'Ste si istí, že chcete začať zdieľať údaje o glukóze s týmto používateľom?',
    confirmRemove:
      'Ste si istí, že chcete odstrániť tohto používateľa zo zoznamu?',
    approvedFollower: 'Schválený sledovateľ',
    rejectFollower: 'Zamietnutý sledovateľ',
    confirmApproved:
      'Ste si istí, že chcete schváliť túto žiadosť o sledovanie?',
    confirmReject:
      'Ste si istí, že chcete zamietnuť túto žiadosť o sledovanie?',
    addTime: 'Čas pridania',
    check: 'Skontrolovať',
    remove: 'Odstrániť',
    removeUserTitle:
      'Ste si istí, že chcete odstrániť tohto používateľa zo zoznamu?'
  },
  settings: {
    title: 'Nastavenia hladiny glukózy',
    unitSet: 'Nastavenia jednotiek',
    targetSet: 'Nastavenie prispôsobeného TIR',
    alertSet: 'Nastavenie upozornení',
    highAlert: 'Upozornenie na vysokú hladinu',
    lowAlert: 'Upozornenie na nízku hladinu',
    urgentLow: 'Naliehavá nízka hladina',
    urgentHigh: 'Naliehavá vysoká hladina',
    target: 'Cieľ'
  },
  pdf: {
    dailyStatistics: 'Denné štatistiky',
    title: 'Správa AGP',
    page: 'Stránka',
    generated: 'Vygenerované',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Čas v cieľovom rozmedzí',
    timeInRange: 'Čas v cieľovom rozmedzí (TIR)',
    agpTitle: 'Ambulantný glukózový profil (AGP)',
    agpSubTitle:
      'AGP je súhrn hodnôt glukózy za obdobie reportu, so zobrazeným mediánom (50 %) a ďalšími percentilmi, ako keby sa vyskytli počas jedného dňa',
    dailyTitle: 'Denný profil glukózy',
    dailySubTitle:
      'Každý denný profil predstavuje obdobie od polnoci do polnoci.',
    device: 'Zariadenie',
    tDevice: 'Koncové zariadenie',
    print: 'Tlačiť',
    model: 'Model',
    deviceSn: 'Sériové číslo zariadenia',
    effectiveData: 'Efektívne údaje',
    days: 'Dni',
    appVer: 'Verzia aplikácie',
    smartPhoneModel: 'Model smartfónu',
    osVersion: 'Verzia OS',
    appSetting: 'Nastavenia aplikácie',
    GoalsforType1andType2Diabetes: 'Ciele pre diabetes typu 1 a typu 2',
    Each1timeinrange15minutes: 'Každé 1 % času v rozmedzí ≈ 15 minút',
    note: 'Pozn.: Jednotka % platí pre štandard DCCT, zatiaľ čo jednotka mmol/mol platí pre štandard IFCC.'
  },
  field: {
    timeCgmActive: 'Čas aktivity CGM',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Priemerná kalibrácia za deň',
    glucoseAbility: 'Variabilita glukózy',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Počet kalibrácií'
  },
  agp: {
    agpTitle: 'Ambulantný glukózový profil (AGP)',
    centerLine: 'Medián',
    areaLine: 'Interval',
    target: 'Cieľové rozmedzie'
  },
  basic: {
    customTir: 'Prispôsobené TIR',
    bloodTip: 'Nastavenia pripomienok glukózy',
    bloodUnit: 'Jednotka glukózy',
    highTip: 'Upozornenie na vysokú hladinu glukózy',
    lowTip: 'Upozornenie na nízku hladinu glukózy',
    unitText: 'Automaticky nastavené podľa regiónu krajiny',
    selectTip:
      'Kliknutím na ikonu vyberte alebo zrušte výber príslušného dátumu',
    selectAll: 'Vybrať všetko'
  },
  report: {
    threeMonth: 'Posledné 3 mesiace',
    sixMonth: 'Takmer 6 mesiacov',
    yearText: 'Posledný rok',
    showAll: 'Zobraziť všetko',
    all: 'Všetko',
    selectDate: 'Vyberte rozsah dátumov',
    to: 'do',
    startDt: 'Dátum začiatku',
    endDt: 'Dátum ukončenia',
    betaTest: 'Beta testovanie',
    bloodData: 'Údaje o glukóze',
    userCount: 'Používateľský účet'
  },
  petDetail: {
    variety: 'Druh',
    type: 'Typ inzulínu',
    freq: 'Frekvencia inzulínu',
    lente: 'Lente',
    insulin: 'Inzulín glargín',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'Správa AGP',
    snNumber: 'Sériové číslo',
    page: 'Stránka',
    createTime: 'Vygenerované',
    petInfo: 'Informácie o domácom zvierati',
    petName: 'Meno domáceho zvieraťa',
    birthday: 'Dátum narodenia',
    freq: 'Frekvencia inzulínu',
    petType: 'Typ domáceho zvieraťa',
    age: 'Vek',
    registerType: 'Typ striekačky',
    basicBloodData: 'Metodika glukózy',
    dbText: 'Čas v rozmedzí (TIR)',
    target: 'Ciele pre diabetes typu 1 a typu 2',
    recordTime: 'Čas záznamu',
    tag: 'Značka',
    event: 'Udalosť',
    eventDetail: 'Podrobnosti o udalosti',
    mulityText: 'Graf trendu glukózy za viac dní',
    mulitySubText:
      'Viacdňové profily glukózy predstavujú časový interval jedného cyklu zariadenia',
    avageBlood: 'Priemerná glukóza',
    bloodText: 'MODD',
    highTip: 'Upozornenie na vysokú hladinu glukózy',
    lowTip: 'Upozornenie na nízku hladinu glukózy',
    cat: 'Mačka',
    dog: 'Pes',
    country: 'Krajina',
    insulinDose: 'Dávka inzulínu',
    weightUnit: 'kg'
  },
  eventDetail: {
    Empty: 'Prázdne',
    After_Breakfast: 'Po raňajkách',
    Before_Lunch: 'Pred obedom',
    Breakfast: 'Raňajky',
    Lunch: 'Obed',
    Dinner: 'Večera',
    Before_Sleep: 'Pred spaním',
    Extra: 'Extra',
    Short_acting: 'Rýchlo pôsobiaci',
    Pre_mixed: 'Predmiešaný',
    Long_acting: 'Dlho pôsobiaci',
    Middle_acting: 'Stredne pôsobiaci',
    hour: 'h',
    minutes: 'min'
  }
};

export default sk;
